import React, { PropTypes, Component } from 'react';
import { Dialog } from 'material-ui';
import QuestionOutline from 'material-ui/svg-icons/action/help-outline';
import { connect } from 'react-redux';
import {
  manageRatePackage,
  saveProductsToContract,
  saveProductInfoChanges,
  saveBillingInfoChanges,
  saveSupplierInfoChanges,
  deleteInsFile,
  updateBuyerInfo,
  copyDataFromAnotherProduct,
  importContractFromTemplate,
} from '../../../../stores/contracting/dialogs/dialog-constants';
import {
  manageExtrasOffers,
} from '../../__storeFiles__/actions';
import { updateFormData } from '../../../../stores/contracting/add-rates-wizard/rates-wizard-actions';
import AddRates from '../add-edit-dialog-content/add-more-rates';
import AddProducts from '../add-edit-dialog-content/add-products';
import CreateRatePackage from '../add-edit-dialog-content/create-rate-packages';
import BillingInfo from '../add-edit-dialog-content/billing-info';
import Allocation from '../add-edit-dialog-content/allocation/allocation';
import EditSeason from '../add-edit-dialog-content/edit-seasons/dialog-container';
import EditRates from '../add-edit-dialog-content/edit-rates/edit-rates-container';
import EditCheckInOut from '../add-edit-dialog-content/edit-checkin-checkout';
import ExtraPolicyDivs from '../add-edit-dialog-content/extra-policy-divs';
import SeasonalCancelPolicies from '../add-edit-dialog-content/seasonal-cancellation-policy/cancellation-policies';
import AddProductPolicy from '../add-edit-dialog-content/add-product-policy';
import Blackouts from '../add-edit-dialog-content/blackouts';
import TermsAndCriteria from '../add-edit-dialog-content/terms-criteria';
import PickupDropoff from '../add-edit-dialog-content/pickup-dropff/pickup-dropoff.jsx';
import ImportFromTemplate from '../add-edit-dialog-content/import-template/import-from-template.jsx';
import CopyDataFromAnotherProduct from '../add-edit-dialog-content/copy-data-from-another-product.jsx';
import OmniImport from '../add-edit-dialog-content/import-template/omni-import';
import ManageExtrasOffers from '../add-edit-dialog-content/manage-extras-offers/manage-extras-offers';
import UpdateProductName from '../add-edit-dialog-content/update-product-name';
import UpdateBeddingConfig from '../add-edit-dialog-content/update-bedding-config';
import UpdateContractPeriod from '../add-edit-dialog-content/update-contracting-period';
import UpdateLocationName from '../add-edit-dialog-content/update-location-name';

const propTypes = {
  addEditContractDialog: PropTypes.object,
  onRequestClose: PropTypes.func,
  contractId: PropTypes.string,
  productId: PropTypes.string,
  type: PropTypes.string,
  takenDateRanges: PropTypes.array,
  saveProductInfoChangesDispatched: PropTypes.func,
  saveSupplierInfoChangesDispatched: PropTypes.func,
  importContractFromTemplateDispatched: PropTypes.func,
  reloadContent: PropTypes.func,
  openGlobalAlert: PropTypes.func,
  rightSideContent: PropTypes.object,
  productsArray: PropTypes.array,
  existingSeasons: PropTypes.array,
  allContractingReadyProducts: PropTypes.array,
  locationName: PropTypes.string,
  contractState: PropTypes.string,
  productsMap: PropTypes.object,
  contractingPeriod: PropTypes.object,
  specialOffersStepper: PropTypes.number,
  addExtraStepper: PropTypes.number,
  RatesFormAndTable: PropTypes.object,
};
class AddEditDialog extends Component {
  render() {
    const {
      addEditContractDialog,
      saveProductInfoChangesDispatched,
      saveSupplierInfoChangesDispatched,
      importContractFromTemplateDispatched,
      reloadContent,
      openGlobalAlert,
      ...extraProps
    } = this.props;

    const { open, note, type, data, saving, example, offersOrExtras } = addEditContractDialog;
    const ContentNode = (() => {
      switch (type) {
        case 'addRates':
          return AddRates;
        case 'addProducts':
          return AddProducts;
        case 'manageRatePackage':
          return CreateRatePackage;
        case 'billingInfo':
          return BillingInfo;
        case 'allocation':
          return Allocation;
        case 'checkInOut':
          return EditCheckInOut;
        case 'policy':
          return ExtraPolicyDivs;
        case 'addProductPolicy':
        case 'editProductPolicy':
          return AddProductPolicy;
        case 'seasonalCancelPolicies':
          return SeasonalCancelPolicies;
        case 'blackouts':
          return Blackouts;
        case 'corporateIdentificationNumber':
        case 'termsAndConditions':
        case 'submissionCriteria':
        case 'marketInfo':
          return TermsAndCriteria;
        case 'pickupDropoff':
          return PickupDropoff;
        case 'importFromTemplate':
          return ImportFromTemplate;
        case 'copyDataFromAnotherProduct':
          return CopyDataFromAnotherProduct;
        case 'manageExtrasOffers':
          return ManageExtrasOffers;
        case 'updateProductName':
          return UpdateProductName;
        case 'updateBeddingConfig':
          return UpdateBeddingConfig;
        case 'UpdateContractPeriod':
          return UpdateContractPeriod;
        case 'UpdateLocationName':
          return UpdateLocationName;
        default:
          return 'div';
      }
    })();
    const px600 = {
      addProducts: 'addProducts',
      manageRatePackage: true,
    };
    const px700 = {
      importFromTemplate: 'importFromTemplate',
      updateBeddingConfig: true,
    };
    const px550 = {
      blackouts: 'blackouts',
      billingInfo: 'billingInfo',
      policy: data.policyType !== 'cancellation',
      addProductPolicy: 'addProductPolicy',
      editProductPolicy: 'editProductPolicy',
    };
    const percent80 = {
      manageExtrasOffers: 'manageExtrasOffers',
      pickupDropoff: 'pickupDropoff',
      submissionCriteria: 'submissionCriteria',
      termsAndConditions: 'termsConditions',
    };
    const percent45 = {
      checkInOut: 'checkInOut',
      copyDataFromAnotherProduct: 'copyDataFromAnotherProduct',
    };
    const percent30 = {
      addRateSet: 'addRateSet',
      allocation: 'allocation',
      seasonalCancelPolicies: true,
      policy: data.policyType === 'cancellation',
    };

    const width = (() => {
      if (px600[type]) return '600px';
      if (px700[type]) return '700px';
      if (px550[type]) return '550px';
      if (percent80[type]) return '80%';
      if (percent45[type]) return '45%';
      if (!percent30[type]) return '30%';
      return '100%';
    })();
    const importTemplate = ({ templateId, contractId, fieldsToImport }) => {
      const onOk = () => {
        return importContractFromTemplateDispatched({ templateId, contractId, fieldsToImport });
      };
      if (data.forNewDraft) {
        onOk();
      } else {
        openGlobalAlert({
          text: 'This action will overwrite the data you currently have, do you want to proceed?',
          onOk,
        });
      }
    };
    const propsForContent = {
      data,
      saving,
      note,
      example,
      offersOrExtras,
      importTemplate,
      saveProductInfoChanges: saveProductInfoChangesDispatched,
      saveSupplierInfoChanges: payload => saveSupplierInfoChangesDispatched(payload),
      openGlobalAlert,
      ...extraProps,
    };
    if (type === 'editSeason') return <EditSeason {...propsForContent} />;
    if (type === 'editRates') return <EditRates {...propsForContent} />;
    if (type === 'omniImport') return <OmniImport {...propsForContent} />;
    return (
      <Dialog
        autoScrollBodyContent
        bodyStyle={{ padding: '0', paddingBottom: '12px' }}
        contentStyle={(() => {
          if (type === 'manageExtrasOffers') return { maxWidth: '1500px', width: '100%' };
          if (type === 'addRates') return { maxWidth: '1000px', width: '100%' };
          return { maxWidth: '880px', width };
        })()}
        open={open}
        title={
          data.title
            ? (
            <div
              className="flex-tc-sb"
              style={{ backgroundColor: '#00BCD4', color: 'white', fontSize: '18px', padding: '16px 2%' }}
            >
              {data.title}{
                extraProps.productId && window.location.pathname.indexOf('product') > -1
                ? ` - ${extraProps.productName} ${extraProps.ratePackageName ? `(${extraProps.ratePackageName})` : ''}`
               : ''
              }
              {
                type === 'allocation'
                ? (
                  <a
                    style={{ height: '30px' }}
                    href="http://support.tourconnect.com/en/articles/1140869-what-is-an-allocation-type-what-does-freesale-or-on-request-mean"
                    target="__blank"
                  >
                    <QuestionOutline color="#fff" style={{ height: '30px', width: '30px' }}/>
                  </a>
                  )
                : <span/>
              }
            </div>)
            : undefined
        }
      >
        <ContentNode
          {...propsForContent}
        />
      </Dialog>
    );
  }
}

AddEditDialog.propTypes = propTypes;

const mapStateToProps = ({ contracting }, { reducerName }) => {
  const leftNav = contracting[reducerName].get('leftNav').toJS();
  const rightSideContent = contracting[reducerName].get('rightSideContent').toJS();
  const { seasons, seasonRates } = rightSideContent;
  return ({
    rightSideContent,
    productId: rightSideContent.productId,
    ratePackageIndex: rightSideContent.ratePackageIndex,
    ratePackageName: rightSideContent.ratePackageName,
    productName: rightSideContent.productName,
    productsArray: leftNav.productsArray,
    existingSeasons: ((seasonRates || []).length > (seasons || []).length ? seasonRates : seasons || []),
    allContractingReadyProducts: leftNav.allContractingReadyProducts || [],
    productType: rightSideContent.productType,
    contractId: leftNav.contractId,
    locationId: leftNav.locationId,
    locationName: leftNav.locationName,
    contractState: leftNav.contractState,
    productsMap: (leftNav.productsArray || []).reduce((result, product) => {
      result[product.productId] = product.productName;
      return result;
    }, {}),
    contractingPeriod: { startDate: new Date(leftNav.startDate), endDate: new Date(leftNav.endDate) },
    specialOffersStepper: contracting.steppers.get('specialOffersStepper'),
    addExtraStepper: contracting.steppers.get('addExtraStepper'),
    addEditContractDialog: contracting.addEditContractDialog.toJS(),
    RatesFormAndTable: {
      ...contracting.addRateSetWizard.toJS(),
    },
  });
};
const mapDispatchToProps = dispatch => ({
  goToStep: payload => dispatch({ type: 'CHANGE_STEPPER_WIZARD_STEP', payload }),
  onRequestClose: () => dispatch({ type: 'CLOSE_ADD_EDIT_CONTRACT_DIALOG' }),
  onTextFieldChange: payload => dispatch({ type: 'ON_CHANGE_TEXTFIELD_IN_ADD_EDIT_DIALOG', payload }),
  onTextFieldChangeWithKeyPath: payload => dispatch({ type: 'ON_CHANGE_TEXTFIELD_WITH_KEYPATH_IN_ADD_EDIT_DIALOG', payload }),
  addOneElementWithKeyPath: payload => dispatch({ type: 'ADD_ONE_ELEMENT_WITH_KEYPATH_ADD_EDIT_DIALOG', payload }),
  deleteOneElementWithKeyPath: payload => dispatch({ type: 'DELETE_ONE_ELEMENT_WITH_KEYPATH_ADD_EDIT_DIALOG', payload }),
  updateDaysOfWeek: payload => dispatch({ type: 'UPDATE_DAYS_OF_WEEK_ADD_EDIT', payload }),
  updateTableCell: payload => dispatch({ type: 'UPDATE_TABLE_CELL_ADD_EDIT', payload }),
  attachInsFile: payload => dispatch({ type: 'ADD_INSURANCE_FILE', payload }),
  removeInsFile: payload => dispatch(deleteInsFile(payload)),

  saveProductsToContract: (...args) => dispatch(saveProductsToContract(...args)),
  manageRatePackage: (...args) => dispatch(manageRatePackage(...args)),
  saveSupplierInfoChangesDispatched: (...args) => dispatch(saveSupplierInfoChanges(...args)),
  saveBillingInfoChanges: (...args) => dispatch(saveBillingInfoChanges(...args)),
  importContractFromTemplateDispatched: (...args) => dispatch(importContractFromTemplate(...args)),
  saveProductInfoChangesDispatched: (...args) => dispatch(saveProductInfoChanges(...args)),
  addOneMoreBlackout: payload => dispatch({ type: 'ADD_ONE_MORE_BLACKOUT', payload }),
  deleteBlackoutDay: payload => dispatch({ type: 'DELETE_ONE_BLACKOUT_DAY', payload }),

  deleteOneAllotment: payload => dispatch({ type: 'DELETE_ONE_ALLOTMENT', payload }),
  addOneMoreAllotment: payload => dispatch({ type: 'ADD_ONE_MORE_ALLOTMENT', payload }),

  updateFormData: (...args) => dispatch(updateFormData(...args)),

  updateBuyerInfo: payload => dispatch(updateBuyerInfo(payload)),

  updateFieldForOfferRates: payload => dispatch({ type: 'UPDATE_ADD_RATES_FIELD', payload }),
  updateFieldWithKeyPathForOfferRates: payload => dispatch({ type: 'UPDATE_ADD_RATES_FIELD_WITH_KEYPATH', payload }),
  updateCellValueForOfferRates: payload => dispatch({ type: 'UPDATE_ADD_RATES_RATES_TABLE_CELL_VALUE', payload }),
  calculateAccomRatesTable: () => dispatch({ type: 'CALCULATE_RATES_TABLE' }),
  calculateStandardNonAccomRatesTable: () => dispatch({ type: 'CALCULATE_STANDARD_NON_ACCOM_RATES_TABLE' }),
  copyDataFromAnotherProduct: payload => dispatch(copyDataFromAnotherProduct(payload)),
  manageExtrasOffers: (...args) => dispatch(manageExtrasOffers(...args)),
  clearAddRateSetWizard: () => dispatch({ type: 'CLEAR_ADD_RATE_SET_WIZARD' }),
  editProductProfile: payload => dispatch({ type: '{draft}EDIT_PRODUCT_PROFILE_INFO', payload }),
  openGlobalAlert: payload => dispatch({
    type: 'open_global_alert',
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddEditDialog);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/add-edit-contract-dialog.jsx